<template>
  <div class="modal__wrapper">
    <div class="modal modal--lightbox">
      <div class="modal__content">
        <div v-if="imgSource.length > 0" class="aspect-ratio aspect-ratio--16-9">
          <img :src="imgSource" class="lightbox__image" />
        </div>
        <iframe v-if="frameSource.length > 0" :src="frameSource" />
        <div v-if="!busy" class="lightbox__controls">
          <a class="link link--edit" v-if="isRemoteFile" @click.prevent="downloadFile">
            <lennoc-icon image="download" />
            <span>{{ getUiString(['claim_details','details','documents','fileview_download']) }}</span>
          </a>
          <a class="link link--edit" @click.prevent="$emit('close')">
            <lennoc-icon image="squared-cross" />
            <span>{{ getUiString(['claim_details','details','documents','fileview_close']) }}</span>
          </a>
        </div>
      </div>
      <lennoc-spinner v-show="busy" isFullscreen="false"></lennoc-spinner>
    </div>
    <div class="modal--background"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { saveAs } from 'file-saver'

export default {
  name: 'BaseFileView',
  props: {
    document: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      imgSource: '',
      frameSource: '',
      busy: false,
      isRemoteFile: false
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      claimId: 'claim/claimId'
    })
  },
  mounted () {
    this.busy = true
    if (Object.prototype.hasOwnProperty.call(this.document, 'fileId')) {
      const data = {
        index: this.document.index,
        fileId: this.document.fileId,
        fileType: this.document.fileType,
        fileName: this.document.fileName
      }
      this.getDocumentFile(data)
    } else {
      const reader = new FileReader()
      reader.onload = (evt) => {
        this.imgSource = evt.target.result
        this.isRemoteFile = false
        this.busy = false
      }
      reader.readAsDataURL(this.document.file)
    }
  },
  methods: {
    async startDownload (data) {
      if (data.index > -1) {
        return await this.$store.dispatch('claim/downloadAttachment', { documentId: data.fileId, ...data })
      }
      return await this.$store.dispatch('downloadFile', data)
    },
    async getDocumentFile (data) {
      const result = await this.startDownload(data)
      if (result) {
        this.setViewFile(result)
      }
      this.busy = false
    },
    setViewFile (data) {
      const url = URL.createObjectURL(data)
      if (this.document.fileType.indexOf('pdf') > -1) {
        this.frameSource = url
      } else {
        this.imgSource = url
      }
      this.isRemoteFile = true
    },
    downloadFile () {
      saveAs(this.imgSource || this.frameSource, this.document.fileName)
    }
  }
}
</script>
